var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import PageHeader from '@/components/page-header/PageHeader';
import ErrorHandler from '@/support/ErrorHandler';
import { DocumentableType, StudentDocumentTemplate, StudentDocumentTemplateIncludes } from '@/models/StudentDocumentTemplate';
import PlanTemplateRow from '@/components/PlanTemplateRow/PlanTemplateRow';
let PlanTemplate = class PlanTemplate extends Vue {
    constructor() {
        // File structure for Typescript files in your Vue project
        // https://tutorials.atabix.com/frontend/typscript_file_structure/
        super(...arguments);
        // #region @Props
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.$pageTitle = 'Project';
        this.isSaving = false;
        this.isAddingStep = false;
        this.planTemplate = null;
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    mounted() {
        this.initialize();
    }
    async initialize() {
        await this.fetchPlanTemplate();
    }
    // #endregion
    // #region Class methods
    appendBlockByType(type = 'text') {
        const newBlock = this.createLearningObjective(type);
        this.appendLearningObjective(newBlock);
    }
    appendLearningObjective(learningObjective) {
        if (!this.planTemplate) {
            return;
        }
        if (!this.planTemplate.blocks) {
            this.planTemplate.blocks = [];
        }
        this.isAddingStep = true;
        if (!learningObjective) {
            learningObjective = this.createLearningObjective();
        }
        this.planTemplate.blocks.push(learningObjective);
        this.isAddingStep = false;
    }
    createLearningObjective(type = 'text') {
        return {
            content: '',
            title: type === 'simple-text' ? '' : '',
            id: '',
            sort: 0,
            type: type,
        };
    }
    onRemoveObjective(index) {
        if (!this.planTemplate) {
            return;
        }
        this.isAddingStep = true;
        if (!this.planTemplate.blocks) {
            return;
        }
        this.planTemplate.blocks.splice(index, 1);
        this.isAddingStep = false;
    }
    generateUpdatePayload() {
        const templateBlocks = (this.planTemplate && this.planTemplate.blocks) || [];
        const parsedBlocks = templateBlocks.map((block) => ({
            content: block.content,
            title: block.title,
            // id: block.id,
            sort: block.sort,
            type: block.type,
        }));
        return {
            name: (this.planTemplate && this.planTemplate.name) || '',
            blocks: parsedBlocks,
        };
    }
    openUpdateSuccessDialog() {
        this.$store.dispatch('openDialog', this.successDialogOptions);
    }
    cancelUpdate() {
        this.$router.back();
    }
    // #endregion
    // #region Async methods
    async fetchPlanTemplate() {
        this.planTemplate = await new StudentDocumentTemplate().include([StudentDocumentTemplateIncludes.BLOCKS]).find(this.$route.params.id);
    }
    async updatePlanTemplate() {
        if (!this.planTemplate) {
            return;
        }
        try {
            this.isSaving = true;
            await this.planTemplate.update(this.generateUpdatePayload());
            this.openUpdateSuccessDialog();
            this.isSaving = false;
        }
        catch (error) {
            ErrorHandler.network(error);
            this.isSaving = false;
        }
    }
    // #endregion
    // #region Getters & Setters
    get successDialogOptions() {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.save', 0, { item: this.$tc('dialogOptions.item.plan') }),
            type: 'success',
            buttons: {
                confirm: {
                    text: this.$tc('dialogOptions.button.ok'),
                },
            },
        };
    }
    get breadcrumbs() {
        const planTemplateName = this.planTemplate && this.planTemplate.name ? this.planTemplate.name : '';
        return [
            { name: this.$tc('student_plan.title', 2), path: '/plan-templates' },
            { name: planTemplateName ? planTemplateName.toString() : '', path: this.$route.path },
        ];
    }
    get canShowDeleteIcon() {
        return !!(this.planTemplate && this.planTemplate.blocks && this.planTemplate.blocks.length > 1);
    }
    get documentableTypes() {
        return [
            {
                text: this.$tc('group_text'),
                value: DocumentableType.GROUP,
            },
            {
                text: this.$tc('user_text'),
                value: DocumentableType.USER,
            },
            {
                text: this.$tc('Goal set'),
                value: DocumentableType.PROJECT,
            },
        ];
    }
};
PlanTemplate = __decorate([
    Component({
        components: {
            PageHeader,
            PlanTemplateRow,
        },
    })
], PlanTemplate);
export default PlanTemplate;
